import { useQueryPopoverStore } from "@/components/ReferenceWrapper/services/useQueryPopoverStore";
import { Node } from "@tiptap/core";

const QueryInfoNode = Node.create({
  name: "query-info",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      qid: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "query-info",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["query-info", HTMLAttributes];
  },

  addNodeView() {
    return ({ node }) => {
      const { qid } = node.attrs;
      const dom = document.createElement("div");

      const style = {
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      };

      Object.assign(dom.style, style);
      dom.title = "Query Info";
      dom.dataset.qid = qid;

      const iconContainer = createInfoIcon();
      dom.appendChild(iconContainer);

      dom.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { showPopover } = useQueryPopoverStore.getState();
        //@ts-expect-error Too lazy to fix this
        showPopover(e.target!, qid);
      };

      dom.dataset.qid = qid;

      return {
        dom,
      };
    };
  },
});

export default QueryInfoNode;

// Create info icon SVG manually but using the same structure as lucide-react
const createInfoIcon = () => {
  const iconElement = document.createElement("div");
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", "20");
  svg.setAttribute("height", "20");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "#3b82f6");
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");

  // Add the same paths as the lucide-react Info icon
  const circle = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "circle"
  );
  circle.setAttribute("cx", "12");
  circle.setAttribute("cy", "12");
  circle.setAttribute("r", "10");

  const line1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
  line1.setAttribute("x1", "12");
  line1.setAttribute("y1", "16");
  line1.setAttribute("x2", "12");
  line1.setAttribute("y2", "12");

  const dot = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  dot.setAttribute("cx", "12");
  dot.setAttribute("cy", "8");
  dot.setAttribute("r", "1");

  svg.appendChild(circle);
  svg.appendChild(line1);
  svg.appendChild(dot);
  iconElement.appendChild(svg);

  return iconElement;
};
